<template>
  <section class="tariff-start">
    <div class="container">
      <div class="promo-block">
        <h3>Присоединяйтесь к платформе доверия!</h3>
        <p>Проверьте первых 5 контрагентов — бесплатно и без регистрации</p>
        <router-link class="cta-button" to="/login">
          Зарегистрироваться
        </router-link>
        <button
          class="cta-button"
          data-bs-toggle="modal"
          data-bs-target="#authModal"
        >
          Проверить компанию
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.tariff-start {
  background: rgba(245, 247, 250, 1);
  padding: 64px 20px;
  color: white;
}
.promo-block {
  background: linear-gradient(270.18deg, #00c782 0.13%, #12986a 99.85%);
  color: #fff;
  padding: 30px 24px;
  border-radius: 30px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  display: flex;
  flex-direction: column;
}
.promo-block h3 {
  margin-bottom: 16px;
  font-size: 40px;
  max-width: 90%;

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.promo-block p {
  font-size: 30px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 20px;
  }
}
.cta-button {
  background: #fff;
  color: rgba(0, 199, 130, 1);
  padding: 12px 32px;
  border-radius: 100px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  margin-top: 24px;
  width: fit-content;

  @media (max-width: 768px) {
    font-size: 16px;
  }
}
</style>
